import BaseService from "../Base-service";

class TicketNotificationService {
  get controllerName() { return "/TicketNotification/"; }

  getTicketNotificationsForCurrentUser(onlyNotSeen) {
    return BaseService.get(this.controllerName + "GetTicketNotificationsForCurrentUser", {onlyNotSeen});
  }

  setRangeTicketNotificationsByTicketIdsToSeenByCurrentUser(filterVM) {
    return BaseService.post(this.controllerName + "SetRangeTicketNotificationsByTicketIdsToSeenByCurrentUser", filterVM);
  }
}

export default new TicketNotificationService();